var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProvider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.33398V12.5007C2.5 14.8577 2.5 16.0362 3.23223 16.7684C3.96447 17.5007 5.14297 17.5007 7.5 17.5007H10.4167M17.5 8.33398V9.58398",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.33398V10.4173",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.4167H18.3333M15.4167 18.3333V12.5",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 14.166H9.16634",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44753 6.60173C8.21252 7.45143 7.35791 8.91716 5.73415 9.12958C4.30044 9.31714 3.21305 8.69057 2.9353 8.42858C2.62907 8.21615 1.93114 7.5364 1.76022 7.11155C1.58929 6.6867 1.7887 5.76619 1.93114 5.39091L2.50053 3.74024C2.63953 3.32564 2.96492 2.34503 3.29851 2.01335C3.63211 1.68167 4.30751 1.66724 4.58551 1.66724H10.4234C11.9261 1.6885 15.2118 1.65383 15.8613 1.66725C16.5108 1.68066 16.901 2.22578 17.015 2.45945C17.9841 4.80965 18.361 6.15563 18.361 6.72918C18.2345 7.34102 17.711 8.49471 15.8613 9.00213C13.9388 9.5295 12.8489 8.50374 12.5069 8.10994M7.65702 8.10994C7.92765 8.44274 8.77656 9.11259 10.0072 9.12958C11.2378 9.14657 12.3004 8.28696 12.6778 7.85503C12.7847 7.72758 13.0154 7.34946 13.2547 6.60173",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProvider);
export default __webpack_public_path__ + "static/media/icon-provider.537c3f5094ac7a9c9ecb5bd102b6f210.svg";
export { ForwardRef as ReactComponent };